<template>
    <CFormTextarea
        :model-value="modelValue"
        :feedback-invalid="invalidFeedback"
        :invalid="invalid"
        @update:modelValue="updateValue"
        @input="inputValue"
    />
</template>

<script>
import { CFormTextarea } from '@coreui/vue-pro'

export default {
    name: 'DFormTextarea',
    components: { CFormTextarea },
    props: {
        isValid: {
            type: Boolean,
            default: null
        },
        invalidFeedback: {
            type: String,
            default: null
        },
        modelValue: {
            default: null,
            type: String
        }
    },
    emits: ['update:modelValue'],
    computed: {
        invalid () {
            return this.isValid === null ? (this.invalidFeedback !== null) : !this.isValid
        }
    },
    methods: {
        updateValue (event) {
            this.$emit('update:modelValue', event)
        },
        inputValue (event) {
            this.$emit('update:modelValue', event.target.value)
        }
    }
}
</script>
